module.exports = __webpack_public_path__ + "img/telepharma.b7f53dd1.svg";